import apiClient from "../../../utilities/apiClient";
import LocalStorage from "../../../utilities/localStorage";

export const get_vendors = (payload) => {
  return apiClient.get(`${apiClient.Urls.vendors_list}`, payload, true);
};

export const get_materials = (payload) => {
  return apiClient.get(`${apiClient.Urls.materials_list}`, payload, true);
};

export const get_vendor_emails = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.vendors_list}?vendor_id=${payload}`,
    "",
    true
  );
};

export const orders = (payload) => {
  return apiClient.post(`${apiClient.Urls.orders}`, payload, true, "file");
};

export const view_AdminOrderDetails = (payload) => {
  const role = LocalStorage.getItem("tata_login_user").roles;
  const clientId = LocalStorage.getItem("client")?.id;
  return apiClient.get(
    //Todo fix permissions
    role[0] === "Admin" || role[0] === "finance"
      ? `${apiClient.Urls.admin_order_view}/${payload}`
      : role[0] === "officer" && clientId === 3
      ? `${apiClient.Urls.new_officer_order_view}/${payload}`
      : role[0] === "user" && clientId === 3
      ? `${apiClient.Urls.new_vendor_order_view}/${payload}`
      : `${apiClient.Urls.view_admin_order_details}/${payload}`,
    "",
    true
  );
};

export const get_orders = (payload) => {
  const role = LocalStorage.getItem("tata_login_user").roles;
  //Todo fix permissions
  return apiClient.get(
    role[0] === "Admin" || role[0] === "finance"
      ? `${apiClient.Urls.admin_order_list}`
      : `${apiClient.Urls.orders_list}?page=${payload?.page}&per_page=${
          payload?.rowsPerPage
        }&search=${payload?.search || ""}`,

    "",
    true
  );
};

export const add_excel_data = (payload) => {
  return apiClient.post(`${apiClient.Urls.add_excel_orders}`, payload, true);
};
export const approve_order_by_vendor = (payload) => {
  return apiClient.patch(
    `${apiClient.Urls.approveOrderByVendor}${payload.order_id}`,
    { reason: payload.reason },
    true
  );
};
export const reject_order_by_vendor = (payload) => {
  return apiClient.patch(
    `${apiClient.Urls.rejectOrderByVendor}${payload.order_id}`,
    { reason: payload.reason },
    true
  );
};
export const get_InvoiceListByOrderId = (payload) => {
  const role = LocalStorage.getItem("tata_login_user").roles;
  return apiClient.get(
    role[0] === "user"
      ? `${apiClient.Urls.getInvoiceListByOrderIdForVendor}/${payload?.order_id}?page=${payload?.page}&per_page=${payload?.per_page}`
      : `${apiClient.Urls.getInvoiceListByOrderIdForOfficer}/${payload?.order_id}?page=${payload?.page}&per_page=${payload?.per_page}`,

    "",
    true
  );
};
export const get_invoiceListForDropdown = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.getInvoiceListForDropdown}${payload}`,
    payload,
    true
  );
};
export const create_ledgerForOfficer = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.createLedgerForOfficer}`,
    payload,
    true,
    "file"
  );
};
export const get_ledgerList = (payload) => {
  const role = LocalStorage.getItem("tata_login_user").roles;

  return apiClient.get(
    role[0] === "user"
      ? `${apiClient.Urls.ledgerListForVendor}/${payload?.order_id}?page=${payload?.page}&per_page=${payload?.per_page}`
      : `${apiClient.Urls.ledgerListForOfficer}/${payload?.order_id}?page=${payload?.page}&per_page=${payload?.per_page}`,
    "",
    true
  );
};
export const get_viewLedgerDetails = (payload) => {
  const role = LocalStorage.getItem("tata_login_user").roles;

  return apiClient.get(
    role[0] === "user"
      ? `${apiClient.Urls.viewLedgerForVendor}/${payload}`
      : `${apiClient.Urls.viewLedgerForOfficer}/${payload}`,
    "",
    true
  );
};
